import React from "react";
import { Link } from "react-router-dom";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-salbox-neutral-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-10 md:gap-20">
          {/* Logo y descripción */}
          <div>
            <div className="mb-4">
              <img
                src="/logoBlancoSalbox.png"
                alt="Salbox"
                className="h-8 w-auto"
              />
            </div>
            <p className="text-salbox-neutral-300 font-lufga">
              Comida casera, calientita y hecha al momento. Sin intermediarios,
              con precios justos.
            </p>
          </div>

          {/* Enlaces */}
          <div>
            <h3 className="font-lufga-semibold text-lg mb-4">Enlaces</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors text-left p-0 border-none bg-transparent cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <a
                  href="/#cobertura"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Cobertura
                </a>
              </li>
              <li>
                <a
                  href="/#como-funciona"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Cómo Funciona
                </a>
              </li>
              <li>
                <a
                  href="/#comparacion"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Comparación
                </a>
              </li>
              <li>
                <a
                  href="/#menu"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Menú
                </a>
              </li>
              <li>
                <a
                  href="/#resenas"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Reseñas
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-lufga-semibold text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Aviso de Privacidad
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link
                  to="/eliminar-cuenta"
                  className="text-salbox-neutral-300 hover:text-white font-lufga transition-colors"
                >
                  Eliminar Cuenta
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-salbox-neutral-700 mt-8 pt-8 text-center">
          <p className="text-salbox-neutral-400 font-lufga">
            © {new Date().getFullYear()} Salbox. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
